module.exports = {
  fields: {
    howWouldYouPreferEngagingWithUs: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'How would you prefer to engage with us? *',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'readyForQuoteAndProduction',
            label:
              'I’m ready to receive my quote, my part is ready for production. I value automation.',
            value: 'readyForQuoteAndProduction',
          },
          {
            id: 'wantSupportDuringProcess',
            label:
              'I would like to have support during the process to get my quote',
            value: 'wantSupportDuringProcess',
          },
        ],
      },
    }, // if support is preferred
    openToReceiveDesignFeedback: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label:
        'Are you open to receiving design feedback that may reduce your cost/lead time?',
      delegateLabel: true,
      optional: true,
      dependsOn: {
        howWouldYouPreferEngagingWithUs: 'wantSupportDuringProcess',
      },
      options: {
        values: [
          {
            id: 'openToReceiveDesignFeedback_false',
            label: 'No, the design is proven and frozen',
            value: 'false',
          },
          {
            id: 'openToReceiveDesignFeedback_true',
            label: 'Yes, I would appreciate feedback',
            value: 'true',
          },
        ],
      },
    },

    helpChossingTech: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label:
        'Would you like help to choose the right manufacturing technology for your part?',
      delegateLabel: true,
      optional: true,
      dependsOn: {
        howWouldYouPreferEngagingWithUs: 'wantSupportDuringProcess',
      },
      options: {
        values: [
          {
            id: 'helpChossingTech_false',
            label: 'No, I’m set on the selected manufacturing technology',
            value: 'false',
          },
          {
            id: 'helpChossingTech_true',
            label: 'Yes, I would appreciate the support',
            value: 'true',
          },
        ],
      },
    },
    helpChossingMaterial: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'Would you like help to choose the right material for your part?',
      delegateLabel: true,
      optional: true,
      dependsOn: {
        howWouldYouPreferEngagingWithUs: 'wantSupportDuringProcess',
      },
      options: {
        values: [
          {
            id: 'helpChossingMaterial_false',
            label: 'No, I’m set on the selected material',
            value: 'false',
          },
          {
            id: 'helpChossingMaterial_true',
            label: 'Yes, I would appreciate support',
            value: 'true',
          },
        ],
      },
    },
    moreAboutPrototype: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'Can you tell us a bit more about the stage of your product? *',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'firstPrototype',
            label: 'First prototype',
            value: 'firstPrototype',
          },
          {
            id: 'prototypeIteration',
            label: 'Iteration of a prototype',
            value: 'prototypeIteration',
          },
          {
            id: 'readyForSmallScaleProduction',
            label: 'Ready for small scale production',
            value: 'readyForSmallScaleProduction',
          },
          {
            id: 'readyForMassProduction',
            label: 'Ready for mass production',
            value: 'readyForMassProduction',
          },
          {
            id: 'personalOrEducational',
            label: 'Personal use or educational purposes',
            value: 'personalOrEducational',
          },
          {
            id: 'other',
            label: 'Other',
            value: 'other',
          },
        ],
      },
    },

    desiredPrize: {
      label:
        'What is the target price per part are you hoping to match (excluding delivery, VAT, customs and other fees)?',
      component: 'forms.TextField',
      placeholder: 'For example, what would be your budget per unit',
      optional: true,
      boldLabel: true,
    },

    whenOrder: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'When are you likely to place an order?',
      delegateLabel: true,
      optional: true,

      options: {
        values: [
          {
            id: 'asSoonAsPossible',
            label: 'As soon as possible',
            value: 'asSoonAsPossible',
          },
          {
            id: 'inNextWeeks',
            label: 'In the next weeks',
            value: 'inNextWeeks',
          },
          {
            id: 'inNextQuarter',
            label: 'In the next quarter',
            value: 'inNextQuarter',
          },
        ],
      },
    },
    sampleUnit: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label:
        'If your order is for many units, do you want us to provide a quote for just a single sample part?',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'yesDoQuoteForOneSampleUnit',
            label:
              'Yes, I would be interested in additionally receiving a quote for a sample of 1 unit for my part.',
            value: 'yesDoQuoteForOneSampleUnit',
          },
          {
            id: 'noDontQuoteSampleUnit',
            label: 'Not necessary. ',
            value: 'noDontQuoteSampleUnit',
          },
          {
            id: 'undecidedSampleUnit',
            label: 'Undecided',
            value: 'undecidedSampleUnit',
          },
        ],
      },
    },
    oneTimeOrAdditional: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label:
        'Is this a one-time order, or do you expect to order additional quantities of these parts in the future? *',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'expectAdditionalQuantities',
            label: 'Yes, I expect to order additional quantities',
            value: 'expectAdditionalQuantities',
          },
          {
            id: 'oneTimeOrder',
            label: 'Likely one time order',
            value: 'oneTimeOrder',
          },
        ],
      },
    },
    expectedNextBatchSized: {
      label: 'What is your expected next batch sizes?',
      component: 'forms.TextField',
      placeholder: '',
      dependsOn: {
        oneTimeOrAdditional: 'expectAdditionalQuantities',
      },
      optional: true,
      boldLabel: true,
    },
    preferredDelivery: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'What is your preferred delivery option? *',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'mostAffordableOption',
            label: 'The most affordable option',
            value: 'mostAffordableOption',
          },
          {
            id: 'fastestOption',
            label: 'The fastest option',
            value: 'fastestOption',
          },
          {
            id: 'bestPriceTimeOption',
            label: 'The best option based on price and time',
            value: 'bestPriceTimeOption',
          },
          {
            id: 'noPreferredOption',
            label: 'No preference',
            value: 'noPreferredOption',
          },
        ],
      },
    },
    locationPreference: {
      label:
        'Do you have a preference for a manufacturing location? We will do our best to match you with the right manufacturer but we cannot guarantee the final quote will come from the chosen location',
      component: 'forms.TextField',
      placeholder: 'E.g. Europe, Asia, USA or locally',
      optional: true,
      boldLabel: true,
    },

    sustainableApproach: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label:
        'Wikifactory is working towards a circular economy. Would you use more sustainable approaches in your part, even at a price trade-off?',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'sustainableApproach_false',
            label:
              'No, I am concerned that it will not meet the specifications I requested',
            value: 'false',
          },
          {
            id: 'sustainableApproach_true',
            label: 'Yes, I would be interested in learning more',
            value: 'true',
          },
        ],
      },
    },
    additionalInfo: {
      label:
        'Is there any additional information about your project that may advise us in getting you the best possible quote?',
      component: 'forms.TextAreaField',
      placeholder:
        'Examples include: design constraints, price targets, sustainability considerations, manufacturing certification requirements, delivery preferences',
      optional: true,
      responsive: true,
      boldLabel: true,
    },
    howToGetQuote: {
      component: 'forms.RadioGroupField',
      appKey: 'label',
      label: 'How do you want to get your quote?',
      delegateLabel: true,
      optional: true,
      options: {
        values: [
          {
            id: 'receiveBestQuoteForDecission',
            label: 'I want to receive the best quote to make a decision',
            value: 'receiveBestQuoteForDecission',
          },
          {
            id: 'receiveQuoteToCompare',
            label:
              'I want to compare from all the matched manufacturers to make a decision',
            value: 'receiveQuoteToCompare',
          },
        ],
      },
    },
  },
  qualityform: {
    formTitle: '',
    noBorder: true,
    fields: [
      'howWouldYouPreferEngagingWithUs',
      'openToReceiveDesignFeedback',
      'helpChossingTech',
      'helpChossingMaterial',
      'moreAboutPrototype',
      'whenOrder',
      'oneTimeOrAdditional',
      'expectedNextBatchSized',
      'preferredDelivery',
      'additionalInfo',
      'desiredPrize',
      'locationPreference',
      'howToGetQuote',
      'sustainableApproach',
    ],
    boldLabel: true,
    autoFocus: 'openToReceiveDesignFeedback',
  },
};
